import { ACTIONS } from '../Constants';

const initialState = {
    byId: {},
    bySectionItemId: {}
};

const bookmarks = (state = initialState, action) => {
    let newById;
    let newBySectionItemId;
    let bookmark;

    switch (action.type) {
        case ACTIONS.GET_MANY_BOOKMARKS: {
            const { bookmarks = [] } = action.payload;

            newById = {
                ...state.byId
            };
            newBySectionItemId = {
                ...state.bySectionItemId
            };

            bookmarks.forEach((bookmark) => {
                newById[bookmark._id] = bookmark;
                newBySectionItemId[bookmark.sectionItemId] = bookmark;
            });

            return {
                ...state,
                byId: newById,
                bySectionItemId: newBySectionItemId
            };
        }
        case ACTIONS.GET_BOOKMARK:
        case ACTIONS.POST_BOOKMARK: {
            ({ bookmark } = action.payload);
            newById = {
                ...state.byId,
                [bookmark._id]: bookmark
            };
            newBySectionItemId = {
                ...state.bySectionItemId,
                [bookmark.sectionItemId]: bookmark
            };
            return {
                ...state,
                byId: newById,
                bySectionItemId: newBySectionItemId
            };
        }

        case ACTIONS.PUT_BOOKMARK: {
            ({ bookmark } = action.payload);

            newById = {
                ...state.byId
            };
            newBySectionItemId = {
                ...state.bySectionItemId
            };

            if (bookmark.isDeleted) {
                delete newById[bookmark._id];
                delete newBySectionItemId[bookmark.sectionItemId];
            }

            return {
                ...state,
                byId: newById,
                bySectionItemId: newBySectionItemId
            };
        }

        default:
            return state;
    }
};

export default bookmarks;
